import {SectionHeader} from './SectionHeader'
import {SectionItem} from './SectionItem'
import {SectionContainer} from './SectionContainer'
import {SectionPullout} from './SectionPullout'
import {SectionContent} from './SectionContent'
import {SectionTemplate} from './SectionTemplate'
import {SectionBlocksTemplate} from './SectionBlocksTemplate'

const SectionRoot = () => {
  return null
}

export const Section = Object.assign(SectionRoot, {
  Container: SectionContainer,
  Content: SectionContent,
  Header: SectionHeader,
  Item: SectionItem,
  Pullout: SectionPullout,
  Template: SectionTemplate,
  BlocksTemplate: SectionBlocksTemplate,
})
